module.exports = __webpack_public_path__ + "static/commerzbank-5978bf1daab26ef7747ccab03e01b2df.png";